<template>
  <div class="Line3">
    <canvas id="camerafeed"/>  
  </div>
</template>

<script>

// import * as THREE from 'three'
// import { BlurredLine, BlurredLineMaterial } from 'three.blurredline'

export default {

  name: 'Line3',
  data: ()=>({

    cues: [],
    helpers: [],
    curves: {},
    curve: 'bezier',
    amount: 2,
    resolution: 25,
    angleBisection: false,
    closed: false,
    color: '#000000',
    lineWidth: 1.0,
    blurWidth: 1.0,
    blur: true,
    opacity: 1.0,
    wireframe: true,
    ready: false,
    loop: 0,
    line_color: 0xffff00,
    pz: null,
    dpt: null

  }),

  mounted() {

    console.log('Line3 !!!');

    const placegroundScenePipelineModule = () => {

      console.log(this);

      const modelFile = 'https://world-bank-prototype.dpt.media/static/tree.glb'  
      const startScale = new THREE.Vector3(0.01, 0.01, 0.01)  // Initial scale value for our model
      const endScale = new THREE.Vector3(2, 2, 2)             // Ending scale value for our model
      const animationMillis = 750                             // Animate over 0.75 seconds
      const raycaster = new THREE.Raycaster()
      const tapPosition = new THREE.Vector2()
      const loader = new THREE.GLTFLoader()  

      this.surface = null  

      const initXrScene = ({ scene, camera, renderer }) => {

        this.ready = true

        renderer.shadowMap.enabled = true
        renderer.shadowMap.type = THREE.PCFSoftShadowMap

        const light = new THREE.DirectionalLight(0xffffff, 1, 100)
        light.position.set(1, 4.3, 2.5)  

        scene.add(light)  // Add soft white light to the scene.
        scene.add(new THREE.AmbientLight(0x404040, 5))  // Add soft white light to the scene.

        light.shadow.mapSize.width = 1024  // default
        light.shadow.mapSize.height = 1024  // default
        light.shadow.camera.near = 0.5  // default
        light.shadow.camera.far = 500  // default
        light.castShadow = true

        this.surface = new THREE.Mesh(
          new THREE.PlaneGeometry(200, 100, 1, 1),
          new THREE.MeshBasicMaterial( { color: 0xffff00, wireframe: true } )
          // new THREE.ShadowMaterial({ opacity: 0.5, })
        )

        // this.surface.rotateX(-Math.PI / 2)
        // this.surface.position.set(0, 0, -10)
        // this.surface.receiveShadow = true
        // scene.add(this.surface)

        camera.position.set(0, 3, 0)
      }

      const animateIn = (model, pointX, pointZ, yDegrees, pointY) => {

        const scale = { ...startScale }
        model.scene.rotation.set(0.0, yDegrees, 0.0)
        model.scene.position.set(pointX, pointY, pointZ)
        model.scene.scale.set(scale.x, scale.y, scale.z)
        model.scene.children[0].children[0].children[0].castShadow = true
        XR8.Threejs.xrScene().scene.add(model.scene)

        new TWEEN.Tween(scale)
          .to(endScale, animationMillis)
          .easing(TWEEN.Easing.Elastic.Out) 
          .onUpdate(() => {
            model.scene.scale.set(scale.x, scale.y, scale.z)
          })
          .start()  
      }

      const placeObject = (pointX, pointZ, py) => {

        loader.load( modelFile, (gltf) => {
            animateIn(gltf, pointX, pointZ, Math.random() * 360, py)
          }
        )

      }

      const placeObjectTouchHandler = (e) => {

        // Call XrController.recenter() when the canvas is tapped with two fingers. This resets the
        // AR camera to the position specified by XrController.updateCameraProjectionMatrix() above.

        // this.loop += 1
        // if(this.loop != 2)
        //   return   
        // else 
        //   this.loop = 0
        
        // console.log('placeObjectTouchHandler');
        // XR8.XrController.recenter()
        // if (e.touches.length === 2) { XR8.XrController.recenter() }
        // if (e.touches.length > 2) { return }

        // If the canvas is tapped with one finger and hits the "surface", spawn an object.
        const { camera } = XR8.Threejs.xrScene()

        this.addCurveLine(camera)
        return




        // calculate tap position in normalized device coordinates (-1 to +1) for both components.

        tapPosition.x = (e.touches[0].clientX / window.innerWidth) * 2 - 1
        tapPosition.y = -(e.touches[0].clientY / window.innerHeight) * 2 + 1

        // Update the picking ray with the camera and tap position.
        raycaster.setFromCamera(tapPosition, camera)

        // Raycast against the "surface" object.
        const intersects = raycaster.intersectObject(this.surface)

        // console.log('xxxxxxx---xxxxxxx');
        // console.log(intersects[0].point);
        // console.log(camera.position);

        if (intersects.length === 1 && intersects[0].object === this.surface) {

          // placeObject(intersects[0].point.x, intersects[0].point.z, 0)

          // this.addLine(intersects[0].point, camera.position)
          // this.addFatLine(intersects[0].point)

          if(this.pz == null) {
            this.pz = camera.position.z 
          }

          this.addCurveLine(intersects[0].point, camera.position.z)
          
 

        }
      }

      return {
        // Pipeline modules need a name. It can be whatever you want but must be unique within your app.
        name: 'placeground',

        // onStart is called once when the camera feed begins. In this case, we need to wait for the
        // XR8.Threejs scene to be ready before we can access it to add content. It was created in
        // XR8.Threejs.pipelineModule()'s onStart method.

        onStart: ({canvas}) => {

          const { scene, camera, renderer } = XR8.Threejs.xrScene()  // Get the 3js sceen from xr3js.

          // XR8.XrController.recenter()
          // Add objects to the scene and set starting camera position.

          if(this.ready == false)
            initXrScene({ scene, camera, renderer })

          // this.surface.position.set(0, 0, -5)

          canvas.addEventListener('touchstart', ()=>{

            // console.log(camera);

            if(this.dpt == null) {
              XR8.XrController.recenter()
              this.dpt = new THREE.Vector3(0, 3, -1)
              this.dpt.applyQuaternion(camera.quaternion)
              this.cues.push(this.dpt)
              this.camera = camera
              this.onLoop()

            }  
            else
              this.onLoop()

            // else {

            //    this.addCurveLine(camera)

            // }

          }, true)  // Add touch listener.
          // canvas.addEventListener('touchmove', placeObjectTouchHandler, true)  // Add touch listener.
          canvas.addEventListener('touchend', ()=>{
            
            // this.cues = []
            // XR8.XrController.recenter()  
            // this.surface.position.set(0, 0, -5)
            // camera.position.set(0, 3, 0)

            // this.dpt = null
            if(this.rafID)
              cancelAnimationFrame(this.rafID)

            // this.cues = []
            this.loop = 0


          }, true) 

          // prevent scroll/pinch gestures on canvas
          // canvas.addEventListener('touchmove', (event) => {
          //   // event.preventDefault()
          //   this.loop += 1
          //   if(this.loop == 5){
          //     this.loop = 0
          //     placeObjectTouchHandler()
          //   }
          //   this.$parent.txt = this.loop
          // })

          // Enable TWEEN animations.

          // const animate = (time) => {
          //   requestAnimationFrame(animate)
          //   TWEEN.update(time)
          // }

          // animate()

          // Sync the xr controller's 6DoF position and camera paremeters with our scene.
          XR8.XrController.updateCameraProjectionMatrix({
            origin: camera.position,
            facing: camera.quaternion,
          })
        },
      }
    }

    const onxrloaded = () => {

      XR8.addCameraPipelineModules([  
        XR8.GlTextureRenderer.pipelineModule(),      // Draws the camera feed.
        XR8.Threejs.pipelineModule(),                // Creates a ThreeJS AR Scene.
        XR8.XrController.pipelineModule(),           // Enables SLAM tracking.
        XRExtras.AlmostThere.pipelineModule(),       // Detects unsupported browsers and gives hints.
        XRExtras.FullWindowCanvas.pipelineModule(),  // Modifies the canvas to fill the window.
        XRExtras.Loading.pipelineModule(),           // Manages the loading screen on startup.
        XRExtras.RuntimeError.pipelineModule(),      // Shows an error image on runtime error.
        placegroundScenePipelineModule(),
      ])

      XR8.run({canvas: document.getElementById('camerafeed')})
    }

    const load = () => { XRExtras.Loading.showLoading({ onxrloaded }) }
    window.onload = () => { window.XRExtras ? load() : window.addEventListener('xrextrasloaded', load) }

  },

  methods:{

    eraseLine() {
      this.dpt = null
      this.cues = []
      var scene = XR8.Threejs.xrScene().scene
      this.clearHelpers(scene)
    },

    onLoop() {
      this.loop += 1
      if(this.loop == 5){
        this.loop = 0
        this.addCurveLine()
      }
      this.rafID = requestAnimationFrame(this.onLoop)  
    },

    clearHelpers(scene) {
      _.each(this.helpers, (helper)=>{
        scene.remove(helper)
      })
      this.helpers = []
    },

    addCurveLine() {

      // console.log(camera);
      // return

      console.log('addCurveLine');

      const camera = this.camera
      let cue =new THREE.Vector3(camera.position.x, camera.position.y, camera.position.z)
          // cue.applyQuaternion(camera.quaternion)

      this.cues.push(cue)
      if(this.cues.length < 1)
        return

      var scene = XR8.Threejs.xrScene().scene
      var points = []

      // const pz = this.pz - _pz
      // this.$parent.txt = pz

      this.clearHelpers(scene)

      _.each(this.cues, (p)=>{
        points.push(new THREE.Vector3(p.x, p.y, p.z))
        // points.push(new THREE.Vector3(p.x, p.y, p.z - pz*1.5))
      })

      const curve = new THREE.CatmullRomCurve3(points)

      // const geometry = new THREE.Geometry();
      // geometry.vertices = curve.points;
      // const material = new THREE.LineBasicMaterial( { color : 0xff0000 } );
      // const curveObject = new THREE.Line( geometry, material );
      // scene.add( curveObject ) 

      // visualize spaced points 

      const sphereGeomtry = new THREE.SphereBufferGeometry( .1 );
      const sphereMaterial = new THREE.MeshBasicMaterial( { color: this.line_color } );
      const spacedPoints = curve.getSpacedPoints( 25*this.cues.length );

      // for (var i = 0; i < spacedPoints.length; i++) {      
      //   !!i && console.log("Distance to prev point:", spacedPoints[i].distanceTo(spacedPoints[i - 1]));    
      // }

      _.each(spacedPoints, (point)=>  {
        const helper = new THREE.Mesh( sphereGeomtry, sphereMaterial );
        this.helpers.push(helper)
        helper.position.copy( point );
        scene.add( helper );
      })

      console.log('curve completed!');

    },

    
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Line3
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
 
  canvas
    width 100%
    height 100%
    opacity 0
    transition opacity .5s
    transition-delay 1

    &.show 
      opacity 1

  &__container
     width 100%
     position relative
     container-height(2)

</style>


